// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1LeSn","requiredAsterisk":"Info_requiredAsterisk__2Sboe"};